import HeaderActions from 'app/src/layouts/HeaderActions'
import EditMyPhoneNumbers from 'app/src/me/EditMyPhoneNumbers'

const ContactInformation = () => {
  return (
    <>
      <HeaderActions />
      <EditMyPhoneNumbers />
    </>
  )
}

export const Component = ContactInformation
export default ContactInformation
